// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2960":"f234e793","4889":"f234e793","5108":"f234e793","8365":"dfa86d51"}[chunkId] + ".chunk.css";
};